module.exports = __webpack_public_path__ + "img/public/SiteIcons/viewAllArrow.svg?0006e35d";